export default __webpack_public_path__ + "static/media/support-button.3ea753ae.svg";